(() => {
      const text = new Map([
        ['Customer Reviews', 'Asiakasarvostelut'],
        ['Be the first to write a review', 'Kirjoita ensimmäinen arvostelu'],
        ['Write a review', 'Kirjoita arvostelu'],
        ['How would you rate this product?', 'Miten arvioisit tämän tuotteen?'],
        ['We would love it if you would share a bit about your experience.', 'Kerro meille kokemuksestasi.'],
        ['Review content (Required)', 'Arvostelu (pakollinen)'],
        ["We'll only contact you about your review if necessary. By submitting your review, you agree to our terms and conditions and privacy policy.", 'Otamme yhteyttä arvosteluasi koskien vain tarvittaessa. Lähettämällä arvostelun hyväksyt käyttöehdot ja tietosuojakäytännön.'],
        ['About you', 'Tietoa sinusta'],
        ['Please tell us more about you.', 'Kerro hieman itsestäsi.'],
        ['Email address (Required)', 'Sähköpostiosoite (pakollinen)'],
        ['We respect your privacy.', 'Kunnioitamme yksityisyyttäsi.'],
        ['Display name (Required)', 'Näyttönimi (pakollinen)'],
        ["This won't be visible to other customers.", 'Tämä ei näy muille asiakkaille.'],
        ['Post review as anonymous', 'Julkaise arvostelu nimettömänä'],
        ['Share a picture', 'Lisää kuva'],
        ['Upload a photo to support your review.', 'Lisää arvosteluasi täydentävä kuva.'],
        ['Click to upload or drag and drop', 'Napsauta ladataksesi tai vedä tiedosto tähän'],
        ['Back', 'Takaisin'],
        ['Next', 'Seuraava'],
        ['Submit', 'Lähetä'],
        ['Submit review', 'Lähetä arvostelu'],
        ['Thanks for your review!', 'Kiitos arvostelustasi!'],
        ['We are processing it and it will appear on the store soon.', 'Käsittelemme arvostelua, ja se näkyy pian kaupassa.'],
        ['Please confirm your email by clicking the link we just sent you. This helps us keep reviews authentic.', 'Vahvista sähköpostiosoitteesi napsauttamalla juuri lähettämäämme linkkiä. Näin voimme varmistaa arvostelujen aitouden.'],
        ['Would you like to share your experience of shopping with us?', 'Haluaisitko kertoa ostokokemuksestasi?'],
        ['We value your feedback and use it to improve. Please share any thoughts or suggestions you have.', 'Arvostamme palautettasi ja käytämme sitä palvelumme kehittämiseen. Kerro ajatuksesi tai ehdotuksesi.'],
        ['Close', 'Sulje'],
      ]);
      const placeholders = new Map([
        ['Start writing here...', 'Kirjoita arvostelusi tähän...'],
        ['Your email address', 'Sähköpostiosoitteesi'],
        ['Display name', 'Näyttönimi'],
      ]);
      const labels = new Map([
        ['Close review form', 'Sulje arvostelulomake'],
        ['Review form pages', 'Arvostelulomakkeen sivut'],
        ['Rating', 'Arvosana'],
        ['Privacy and Terms', 'Tietosuoja ja ehdot'],
        ['Review form navigation', 'Arvostelulomakkeen navigointi'],
        ['Previous step', 'Edellinen vaihe'],
        ['Next step', 'Seuraava vaihe'],
        ['Share a picture', 'Lisää kuva'],
      ]);
      const translate = (root) => {
        if (!(root instanceof Element) && root !== document.body) return;
        const selector = '.jdgm-widget, .jdgm-write-review-modal, .jdgm-rev-widg';
        const scopes = root === document.body ? [...document.querySelectorAll(selector)] : [...(root.matches?.(selector) ? [root] : []), ...root.querySelectorAll(selector)];
        for (const scope of scopes) {
          const nodes = [];
          for (const element of [scope, ...scope.querySelectorAll('*')]) {
            for (const node of element.childNodes) if (node.nodeType === 3) nodes.push(node);
          }
          for (const node of nodes) {
            const value = node.nodeValue.replace(/\s+/g, ' ').trim();
            const replacement = text.get(value);
            if (!replacement) continue;
            const leading = node.nodeValue.match(/^\s*/)?.[0] || '';
            const trailing = node.nodeValue.match(/\s*$/)?.[0] || '';
            node.nodeValue = leading + replacement + trailing;
          }
          for (const element of scope.querySelectorAll('[placeholder]')) {
            const replacement = placeholders.get(element.getAttribute('placeholder'));
            if (replacement) element.setAttribute('placeholder', replacement);
          }
          for (const element of scope.querySelectorAll('[aria-label]')) {
            const value = element.getAttribute('aria-label');
            const star = value.match(/^(\d+) stars?$/);
            element.setAttribute('aria-label', star ? star[1] + ' tähteä' : labels.get(value) || value);
            if (star && element.hasAttribute('title')) element.setAttribute('title', star[1] + ' tähteä');
          }
          for (const element of scope.querySelectorAll('.jdgm-write-review-modal__gdpr-statement')) {
            if (!element.textContent.includes("We'll only contact you")) continue;
            element.innerHTML = 'Otamme yhteyttä arvosteluasi koskien vain tarvittaessa. Lähettämällä arvostelun hyväksyt <a href="https://judge.me/terms" target="_blank" rel="nofollow noopener">käyttöehdot</a> ja <a href="https://judge.me/privacy" target="_blank" rel="nofollow noopener">tietosuojakäytännön</a>.';
          }
          for (const element of scope.querySelectorAll('.jdgm-write-review-modal__media-upload-prompt')) {
            if (!element.textContent.includes('Click to upload')) continue;
            element.innerHTML = '<b>Napsauta ladataksesi</b> tai vedä tiedosto tähän';
          }
        }
      };
      const run = () => translate(document.body);
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
      else run();
      new MutationObserver(() => run()).observe(document.documentElement, { childList: true, subtree: true });
})();
